import { breakpoints } from '../styles/grid';
import isClient from './isClient';

/**
 * @param {number} width
 * @returns {string}
 */
export const currentBreakpoint = (width) => {
  if (width <= breakpoints.xs - 1) {
    return 'xs';
  }
  if (width >= breakpoints.xs && width <= breakpoints.sm) {
    return 'sm';
  }
  if (width > breakpoints.sm && width <= breakpoints.md) {
    return 'md';
  }
  if (width >= breakpoints.lg && width < breakpoints.xl) {
    return 'lg';
  }
  return 'xl';
};

/**
 * Description placeholder
 *
 * @returns {string}
 */
const getBreakpoint = () => {
  if (!isClient()) {
    console.warn("Don't use getBreakpoint in server side context");
    return 'lg'; // Fallback-Breakpoint
  }

  return currentBreakpoint(window.innerWidth);
};

export default getBreakpoint;
